import React from 'react';
import useAiMentionsContent from "../../hooks/useAiMentionsContent";
import {openWhatsapp} from "../../utils/whatsapp";
import PreviewRibbon from "../main/hero/PreviewRibbon";
import AiMentionsHero from "./AiMentionsHero";
import TrustStrip from "./TrustStrip";
import WhyNow from "./WhyNow";
import Zigzag from "./Zigzag";
import Stepper from "./Stepper";
import Proof from "./Proof";
import AiMentionsPackages, {AI_MENTIONS_PACKAGES_ANCHOR} from "./AiMentionsPackages";
import AiMentionsFaq from "./AiMentionsFaq";
import FinalCta from "./FinalCta";
import './ai-mentions.css';

const prefersReducedMotion = () =>
    typeof window.matchMedia === 'function'
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// scrollIntoView + the target's CSS scroll-margin-top, rather than hardcoded
// header math: the AppBar is 92px only on desktop and auto-height on mobile,
// and the announcement bar may sit above it.
const scrollToSection = (elementId: string) => {
    const element = document.getElementById(elementId);
    if (!element) {
        return;
    }

    element.scrollIntoView({
        behavior: prefersReducedMotion() ? 'auto' : 'smooth',
        block: 'start',
    });
};

const AiMentions: React.FC = () => {
    const {content, isPreview} = useAiMentionsContent();

    // Hero primary and the final CTA share ONE action, by design
    const handleWhatsappCta = () => openWhatsapp(content.whatsapp.number, content.whatsapp.prefill);
    const handleScrollToPackages = () => scrollToSection(AI_MENTIONS_PACKAGES_ANCHOR);

    return (
        <div className="lnk-aim" dir="rtl">
            <AiMentionsHero
                hero={content.hero}
                chatDemo={content.chatDemo}
                onPrimaryCta={handleWhatsappCta}
                onSecondaryCta={handleScrollToPackages}
            />
            <TrustStrip/>
            <WhyNow content={content.whyNow}/>
            <Zigzag content={content.twoMinutes}/>
            <Stepper steps={content.steps} closing={content.stepsClosing}/>
            <Proof content={content.proof}/>
            <AiMentionsPackages/>
            <AiMentionsFaq/>
            <FinalCta
                content={content.finalCta}
                onCta={handleWhatsappCta}
                onSecondaryLink={handleScrollToPackages}
            />

            {isPreview && <PreviewRibbon/>}
        </div>
    );
};

export default AiMentions;
